// Section 24.15: store actions are wrapped by withBoundary; this catches what escapes into
// rendering (a real bug) and shows the error card with the same diagnostics bundle instead of a
// blank page. It reads the game once, at the moment of failure, to build the bundle.
import { Component, type ComponentChildren } from 'preact';
import { diagnosticsOf, game, toTitle, type UiError } from '../../store';
import { uiText } from '../text/en';
import { ErrorCard } from './notices';

interface State {
  error: UiError | null;
}

export class ErrorBoundary extends Component<{ children: ComponentChildren }, State> {
  override state: State = { error: null };

  override componentDidCatch(error: unknown): void {
    const stack = error instanceof Error ? (error.stack ?? error.message) : String(error);
    const message = error instanceof Error ? error.message : String(error);
    this.setState({
      error: {
        code: 'unknown',
        message,
        diagnostics: JSON.stringify(diagnosticsOf(game.peek(), 'render', stack)),
      },
    });
  }

  override render() {
    const { error } = this.state;
    if (error === null) return this.props.children;
    return (
      <main class="title">
        <ErrorCard
          error={error}
          title={uiText.error.render}
          onDismiss={() => {
            toTitle();
            this.setState({ error: null });
          }}
        />
      </main>
    );
  }
}
